exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".placeHolderImg__27ntw{width:200px;height:200px;-o-object-fit:cover;object-fit:cover}@media (max-width:768px){.placeHolderImg__27ntw{width:100%;height:200px;-o-object-fit:cover;object-fit:cover}}", "", {"version":3,"sources":["/usr/src/app/src/components/CategoryItem/CategoryImage.scss"],"names":[],"mappings":"AAAA,uBACI,YACA,aACA,oBAAA,gBAAiB,CACpB,yBAGG,uBACI,WACA,aACA,oBAAA,gBAAiB,CACpB,CAAA","file":"CategoryImage.scss","sourcesContent":[".placeHolderImg {\n    width: 200px;\n    height: 200px;\n    object-fit: cover;\n}\n\n@media (max-width: 768px) {\n    .placeHolderImg {\n        width: 100%;\n        height: 200px;\n        object-fit: cover;\n    }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"placeHolderImg": "placeHolderImg__27ntw"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/CategoryItem/CategoryImage.scss
// module id = eIF6
// module chunks = 0